import React, { useState } from 'react';
import PageLoadingSpinner from '../components/PageLoadingSpinner';
import { COMPANY_INFO } from '../config/companyInfo';

function ContactPage() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const form = e.target;
    const data = new FormData(form);
    try {
      const res = await fetch('https://formspree.io/f/xwpbnejl', {
        method: 'POST',
        body: data,
        headers: {
          Accept: 'application/json',
        },
      });
      if (res.ok) {
        setSubmitted(true);
      } else {
        setError('Mesaj gönderilemedi. Lütfen tekrar deneyin.');
      }
    } catch {
      setError('Sunucuya ulaşılamıyor. Lütfen tekrar deneyin.');
    }
    setLoading(false);
  };

  return (
    <>
      <PageLoadingSpinner show={loading} fullscreen />
      <div className="container py-5">
        <h2 className="mb-4 text-center">İletişim</h2>
        <div className="row justify-content-center">
          <div className="col-md-7">
            <div className="p-4 rounded-3 mb-4" style={{ background: '#fff0f3', boxShadow: '0 2px 12px rgba(220,53,69,0.04)' }}>
              {submitted ? (
                <div className="alert alert-success" role="alert">
                  Mesajınız başarıyla gönderildi. En kısa sürede sizinle iletişime geçeceğiz.
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">Adınız Soyadınız</label>
                    <input type="text" className="form-control" id="name" name="name" required style={{ background: '#fff' }} />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="company" className="form-label">Şirket İsmi</label>
                    <input type="text" className="form-control" id="company" name="company" required style={{ background: '#fff' }} />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">E-posta Adresiniz</label>
                    <input type="email" className="form-control" id="email" name="email" required style={{ background: '#fff' }} />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="topic" className="form-label">Konu</label>
                    <select className="form-control" id="topic" name="topic" required style={{ background: '#fff' }}>
                      <option value="">Konu seçiniz</option>
                      <option value="Lisans">Lisans</option>
                      <option value="Google Chrome Eklentisi">Google Chrome Eklentisi</option>
                      <option value="Teknik Destek">Teknik Destek</option>
                      <option value="Diğer">Diğer</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="message" className="form-label">Mesajınız</label>
                    <textarea className="form-control" id="message" name="message" rows="5" required style={{ background: '#fff' }}></textarea>
                  </div>
                  {error && <div className="alert alert-danger py-2">{error}</div>}
                  <button type="submit" className="btn btn-danger w-100" disabled={loading}>
                    {loading ? 'Gönderiliyor...' : 'Gönder'}
                  </button>
                </form>
              )}
            </div>
            <div className="mt-4 p-3 rounded-3" style={{
              background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
              boxShadow: '0 4px 15px rgba(220, 53, 69, 0.3)'
            }}>
              <p className="mb-0 text-white d-flex align-items-center justify-content-center gap-2" style={{fontSize: '0.95rem', fontWeight: '500'}}>
                <a href="mailto:info@katipotomasyonu.com" className="text-white text-decoration-none" title="E-posta gönder">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16" style={{cursor: 'pointer'}}>
                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.708 2.825L15 11.118V5.383zM14.803 12 10.2 8.911l-1.428.857a.5.5 0 0 1-.544 0L6.8 8.911 2.197 12A1 1 0 0 0 3 13h10a1 1 0 0 0 .803-1zM1 11.118l4.708-2.91L1 5.383v5.735z"/>
                  </svg>
                </a>
                <span>
                  <strong>{COMPANY_INFO.email}</strong> adresine e-posta gönderebilirsiniz.
                </span>
              </p>
            </div>
            {/* Tanıtıcı bilgiler (6563 sayılı Kanun m.3, ETHS Yönetmeliği m.5): "İletişim"
                başlığı altında unvan, MERSİS, merkez adresi, KEP, e-posta ve telefon. */}
            <div className="mt-4 p-3 rounded-3 border bg-white small" style={{ lineHeight: 1.7 }}>
              <h5 className="mb-2">Şirket Bilgileri</h5>
              <div><strong>Unvan:</strong> {COMPANY_INFO.legalName}</div>
              <div><strong>MERSİS No:</strong> {COMPANY_INFO.mersis}</div>
              <div><strong>Merkez Adresi:</strong> {COMPANY_INFO.address}</div>
              <div><strong>KEP Adresi:</strong> {COMPANY_INFO.kep}</div>
              <div><strong>E-posta:</strong> <a href={`mailto:${COMPANY_INFO.email}`}>{COMPANY_INFO.email}</a></div>
              <div><strong>Telefon:</strong> <a href={COMPANY_INFO.phoneHref}>{COMPANY_INFO.phone}</a></div>
              {COMPANY_INFO.etbisRegistered && (
                <div>
                  <strong>ETBİS:</strong> E-ticaret hizmet sağlayıcısı olarak kayıtlıdır (
                  <a href={COMPANY_INFO.etbisQueryUrl} target="_blank" rel="noreferrer">kaydı görüntüle</a>)
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactPage;
